export function compareNetworkTableRows(
  a: Record<string, unknown>,
  b: Record<string, unknown>,
  key: string,
  direction: "asc" | "desc",
): number {
  const av = a[key];
  const bv = b[key];
  let cmp = 0;

  if (key === "provider_name") {
    cmp = String(av ?? "").localeCompare(String(bv ?? ""), undefined, { sensitivity: "base" });
  } else {
    const an = typeof av === "number" ? av : Number(av);
    const bn = typeof bv === "number" ? bv : Number(bv);
    const aValid = av != null && av !== "" && !Number.isNaN(an);
    const bValid = bv != null && bv !== "" && !Number.isNaN(bn);
    if (!aValid && !bValid) cmp = 0;
    else if (!aValid) cmp = 1;
    else if (!bValid) cmp = -1;
    else cmp = an - bn;
  }

  if (cmp === 0 && key !== "provider_name") {
    cmp = String(a.provider_name ?? "").localeCompare(String(b.provider_name ?? ""), undefined, {
      sensitivity: "base",
    });
  }

  return direction === "asc" ? cmp : -cmp;
}
